import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IHostedPageData } from './types';

export interface ICheckoutState {
  loading: boolean;
  ready: boolean;
  hostedPage?: IHostedPageData;
}

export const initialState: ICheckoutState = {
  loading: true,
  ready: false,
};

export const statePropName = 'checkout';

const checkoutSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    initCheckout(state: ICheckoutState) {
      return { ...initialState };
    },
    checkoutReady(state: ICheckoutState) {
      state.loading = false;
      state.ready = true;
    },
    startCheckout(state: ICheckoutState, action: PayloadAction<string>) {
      // No state change needed for startCheckout
    },
    hostedPageLoaded(state: ICheckoutState, action: PayloadAction<IHostedPageData>) {
      state.hostedPage = action.payload;
    },
  },
});

export const CheckoutActions = checkoutSlice.actions;
export default checkoutSlice.reducer;
